import {
  ExamAttempt,
} from '../../../components/ExamViewer/types';
import { Question } from '../../../services/exams/types';

// convert an array of question attempts to an object with questionId as key
export const questionAttemptsArrayToExamAttempt = (questionAttempts: any[]) => {
  if (!questionAttempts) return undefined;
  return questionAttempts.reduce((
    acc: ExamAttempt, questionAttempt: any,
  ) => {
    acc[questionAttempt.questionId] = questionAttempt;
    return acc;
  },
  {});
};

export const getExamMCQMarks = (questions: Question[], examAttempt: ExamAttempt) => {
  let correct = 0;
  let total = 0;
  questions.forEach((question) => {
    const questionAttempt = examAttempt[question.questionId];
    if (questionAttempt?.response === question.mcqOpts?.answer) {
      correct += question.maxMark;
    }
    total += question.maxMark;
  });
  return { correct, total };
};
